<form [formGroup]="dividendBelasting">
    <div *ngIf="ingehoudenDividendBelasting.length > 0">
        <div formArrayName="ingehoudenDividendBelasting" class="row">
            <div *ngFor="let loon of ingehoudenDividendBelasting.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Rekeningnummer' : ''"
                                                class="col-auto custom-input-250"
                                                formControlName="rekeningNummer"
                                                id="rekeningNummer"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Dividend box 3' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="dividendBox3"
                                                  id="dividendBox3"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Div.belasting box 3' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="dividendbelastingBox3"
                                                  id="dividendbelastingBox3"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                @if (aangifte.box2 !== undefined) {
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Dividend box 2' : ''"
                                                      align="right"
                                                      class="col-auto custom-input-150"
                                                      formControlName="dividendBox2"
                                                      id="dividendBox2"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Div.belasting box 2' : ''"
                                                      align="right"
                                                      class="col-auto custom-input-150"
                                                      formControlName="dividendbelastingBox2"
                                                      id="dividendbelastingBox2"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                }
                <snelstart-ui-button (click)="verwijderRij(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
</form>

<div *ngIf="ingehoudenDividendBelasting.length === 0">
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                         type="link">Dividendbelasting invullen
    </snelstart-ui-button>
</div>
<div *ngIf="ingehoudenDividendBelasting.length > 0">
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                         type="link">Dividendbelasting toevoegen
    </snelstart-ui-button>
</div>
